import { render, staticRenderFns } from "./PxIcons.vue?vue&type=template&id=2aabcf37&scoped=true&"
import script from "./PxIcons.vue?vue&type=script&lang=js&"
export * from "./PxIcons.vue?vue&type=script&lang=js&"
import style0 from "./PxIcons.vue?vue&type=style&index=0&id=2aabcf37&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aabcf37",
  null
  
)

export default component.exports